// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.main-div {
  margin-left: 13%;
  margin-right: 13%;
  margin-top: 20px;
  margin-bottom: 20px;
}

@media (max-width: 1024px) {
  .main-div {
    margin-top: 80px;
  }
}
.confirm-block-heading {
  font-size: 14px;
  color: #191919;
  font-family: "Omnes-ATT-W02", Arial;
  opacity: 1;
  text-align: left;
  line-height: 20px;
}
@media (max-width: 1024px) {
  .confirm-block-heading {
    width: 90px;
  }
}

#faciliate-heading {
  width: 60%;
  font-weight: 600;
}

.confirm-section {
  padding: 0px 15px 15px 15px;
}

.confirm-info {
  width: 100%;
  float: left;
  margin-top: 2%;
  margin-bottom: 2%;
}
.confirm-blocks {
  display: block;
  margin-right: 10%;
}
@media (max-width: 1024px) {
  .confirm-blocks {
    margin-right: 9px;
  }
}

.continue-section {
  width: 100%;
  height: 50px;
  margin-bottom: 40px;
}

#cancel-option {
  float: right;
  margin-right: 20px;
  font-size: 18px;
  margin-top: 12px;
}

#continue-option {
  float: right;
}

.abmlegalAgreement {
  display: flexbox;
  top: 1189px;
  left: 215px;
  width: 100%;
  background: #F2F2F2 0% 0% no-repeat padding-box;
  opacity: 1;
  font-size: 16px !important;
  padding: 15px 15px 15px 15px;
}
.abmlegalAgreement h3 {
  margin: 0px !important;
}
.abmlegalAgreement p {
  margin: 0px !important;
}
@media (max-width: 1024px) {
  .abmlegalAgreement p {
    margin-left: -5px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/app/pages/abm-faciliate-enrollment/abm-faciliate-enrollment.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AAlJA;EACI,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AAoJJ;;AFjII;EEfJ;IACI,gBAAA;EAoJF;AACF;AAnJA;EACI,eAAA;EACA,cAAA;EACA,mCAAA;EACA,UAAA;EACA,gBAAA;EACA,iBAAA;AAqJJ;AF/II;EEZJ;IAQI,WAAA;EAuJF;AACF;;AApJA;EACI,UAAA;EACA,gBAAA;AAuJJ;;AApJE;EACE,2BAAA;AAuJJ;;AArJA;EACI,WAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;AAwJJ;AAlJA;EACI,cAAA;EACA,iBAAA;AAoJJ;AFxKI;EEkBJ;IAIQ,iBAAA;EAsJN;AACF;;AAnJA;EACI,WAAA;EACA,YAAA;EACA,mBAAA;AAsJJ;;AAnJA;EACI,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AAsJJ;;AApJA;EACI,YAAA;AAuJJ;;AApJA;EACI,gBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,+CAAA;EACA,UAAA;EACA,0BAAA;EACA,4BAAA;AAuJJ;AAtJI;EACI,sBAAA;AAwJR;AApJI;EACI,sBAAA;AAsJR;AF/MI;EEwDA;IAGQ,4BAAA;EAwJV;AACF","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","@import '../../../lib/ng2-sapmp/src/assets/style/mixinfunction.scss';\n.main-div {\n    margin-left: 13%;\n    margin-right: 13%;\n    margin-top: 20px;\n    margin-bottom: 20px;\n}\n\n@include respond-to('small') {\n.main-div {\n    margin-top: 80px;\n}}\n.confirm-block-heading {\n    font-size: 14px;\n    color: #191919;\n    font-family: 'Omnes-ATT-W02', Arial;\n    opacity: 1;\n    text-align: left;\n    line-height: 20px;\n    @include respond-to('small') {\n    width: 90px;\n    }\n}\n\n#faciliate-heading {\n    width: 60%;\n    font-weight: 600;\n  }\n\n  .confirm-section {\n    padding: 0px 15px 15px 15px;\n}\n.confirm-info {\n    width: 100%;\n    float: left;\n    margin-top: 2%;\n    margin-bottom: 2%;\n    @include respond-to('small') {\n        // width: 325px;\n    }\n}  \n\n.confirm-blocks {\n    display: block;\n    margin-right: 10%;\n    @include respond-to('small') {\n        margin-right: 9px;\n    }\n}\n\n.continue-section {\n    width: 100%;\n    height: 50px;\n    margin-bottom: 40px;\n}\n\n#cancel-option {\n    float: right;\n    margin-right: 20px;\n    font-size: 18px;\n    margin-top: 12px;\n}\n#continue-option {\n    float: right;\n}\n\n.abmlegalAgreement {\n    display: flexbox;\n    top: 1189px;\n    left: 215px;\n    width: 100% ;\n    background: #F2F2F2 0% 0% no-repeat padding-box;\n    opacity: 1;\n    font-size: 16px !important;\n    padding: 15px 15px 15px 15px;\n    h3 {\n        margin: 0px  !important;\n        // font-size: 24px !important;\n    }\n\n    p {\n        margin: 0px !important;\n        @include respond-to ('small') {\n            margin-left: -5px !important;\n            // width: 293px !important;\n        }\n    }\n\n    @include respond-to ('small') {\n        // width: 310px !important ;\n        // height: 275px;\n    }\n      @media only screen and\n           (max-width: 590px) and (min-width:420px) {\n            //    width: 360px ;\n        }\n       @media only screen and\n          (max-width: 1320px) and (min-width:600px) {\n            //   width: 800px ;\n       }\n}\n\n.abm-faciliate-info{\n    @include respond-to (small){\n        // width: 325px;\n      }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
